module.exports = __webpack_public_path__ + "img/louuuise-0723b280-ef25-4c46-9bab-08d94053bf76.png";